import isEmpty from 'lodash/isEmpty'

import { appActions, appSelectors } from '../../../redux/reducers/app'
import store from '../../../redux/store'

store.subscribe(() => {
	const state = store.getState()

	const isInstalled = appSelectors.isInstalled(state)
	const isInstalledDone = appSelectors.isInstalledDone(state)
	const linkedProfileDone = appSelectors.linkedProfileDone(state)
	const appProfileDone = appSelectors.appProfileDone(state)
	const appProfile = appSelectors.appProfile(state)
	const linkedInfo = appSelectors.linkedProfile(state)
	const auth = appSelectors.auth(state)

	if (!isInstalled && !appProfileDone) {
		store.dispatch(appActions.appAuth('none'))
	}

	if (isInstalledDone && linkedProfileDone && appProfileDone) {
		const isProfileReady = isInstalled && !isEmpty(appProfile)

		let nextStatus: 'auth' | 'none' = 'none'

		if (isProfileReady && linkedInfo !== null) {
			const { timezoneOffset, workingHoursSet } = appProfile

			if (timezoneOffset !== null && workingHoursSet) {
				nextStatus = 'auth'
			}
		}

		if (auth !== nextStatus) {
			store.dispatch(appActions.appAuth(nextStatus))
		}
	}
})
